import jsPDF from 'jspdf';
import 'jspdf-autotable';

const LOGO_BASE64 = 'data:image/jpeg;base64,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';

export function exportToCSV(headers, rows, filename) {
  const sanitize = (val) => {
    if (val === null || val === undefined) return '';
    let str = String(val);
    str = str.replace(/₹/g, 'Rs. ');
    str = str.replace(/[—–]/g, '-');
    str = str.replace(/[‘’]/g, "'");
    str = str.replace(/[“”]/g, '"');
    return str;
  };

  const csvRows = [];

  // Add headers
  csvRows.push(headers.map(h => `"${sanitize(h).replace(/"/g, '""')}"`).join(','));

  // Add data rows
  rows.forEach(row => {
    const values = row.map(val => {
      const cleanVal = sanitize(val).replace(/"/g, '""');
      return `"${cleanVal}"`;
    });
    csvRows.push(values.join(','));
  });

  const csvString = '\uFEFF' + csvRows.join('\r\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// Helper to export clean, printable PDF report using jsPDF AutoTable
// options: { customFooter: string[] | null, boldLastColumn: boolean }
export function exportToPDF(title, headers, rows, filename, options = {}) {
  const doc = new jsPDF('landscape'); // Landscape gives more room for columns
  const pageW = doc.internal.pageSize.getWidth();

  // Draw elegant report header
  doc.setFillColor(64, 23, 4); // Brand navy header bar
  doc.rect(0, 0, pageW, 35, 'F');

  // Add logo image
  doc.addImage(LOGO_BASE64, 'JPEG', 14, 8, 18, 18);

  doc.setFont('times', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(201, 168, 76); // Gold text
  doc.text('New Sowtha Reports', 38, 15);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(200, 200, 200);
  doc.text(`Report Title: ${title}`, 38, 23);
  doc.text(`Generated At: ${new Date().toLocaleString('en-IN')}`, 38, 29);

  doc.setTextColor(255, 255, 255);
  doc.setFont('times', 'bold');
  doc.setFontSize(12);
  doc.text('CONFIDENTIAL / PRINTED REPORT', pageW - 14, 15, { align: 'right' });

  // Clean headers for PDF if any contain ₹
  const cleanHeaders = headers.map(h => String(h).replace(/₹/g, 'Rs.'));

  // Determine footer row
  let footerRow;
  if (options.customFooter) {
    // Use caller-supplied footer row directly
    footerRow = options.customFooter.map(f => String(f).replace(/₹/g, 'Rs.'));
  } else {
    // Auto-compute totals for columns that should be summed
    footerRow = cleanHeaders.map((header, colIndex) => {
      const headerLower = header.toLowerCase();
      const isTotal = headerLower.includes('total') || headerLower.includes('amount') || headerLower.includes('quantity') || headerLower.includes('qty') || headerLower.includes('received');
      const isRateOrCost = headerLower.includes('rate') || headerLower.includes('cost') || headerLower.includes('price') || headerLower.includes('gst') || headerLower.includes('balance');

      if (isTotal && !isRateOrCost) {
        let sum = 0;
        let hasValidNumber = false;
        rows.forEach(row => {
          const val = row[colIndex];
          if (val !== undefined && val !== null) {
            const cleanVal = String(val).replace(/[^\d.-]/g, '');
            const num = parseFloat(cleanVal);
            if (!isNaN(num)) { sum += num; hasValidNumber = true; }
          }
        });
        if (hasValidNumber) {
          if (headerLower.includes('(rs.)') || headerLower.includes('total') || headerLower.includes('amount')) {
            return `Rs. ${sum.toFixed(2)}`;
          }
          return String(sum);
        }
      }
      return '';
    });

    if (footerRow[0] === '') footerRow[0] = 'Total Summary';
  }

  const lastColIndex = cleanHeaders.length - 1;
  const boldLastColumn = options.boldLastColumn || false;

  // Draw AutoTable
  doc.autoTable({
    startY: 42,
    head: [cleanHeaders],
    body: rows,
    foot: [footerRow],
    showFoot: 'lastPage',
    theme: 'grid',
    headStyles: {
      fillColor: [64, 23, 4],
      textColor: 255,
      fontSize: 8,
      fontStyle: 'bold',
      cellPadding: 4,
      valign: 'middle'
    },
    bodyStyles: {
      fontSize: 8,
      cellPadding: 4,
      textColor: [50, 50, 50],
      valign: 'middle'
    },
    footStyles: {
      fillColor: [64, 23, 4],
      textColor: [201, 168, 76], // Gold color
      fontSize: 8,
      fontStyle: 'bold',
      cellPadding: 4,
      valign: 'middle'
    },
    alternateRowStyles: {
      fillColor: [250, 250, 248]
    },
    didParseCell: function(data) {
      if (data.section === 'body') {
        const isPayment = (data.row.raw && data.row.raw[0] === 'PAYMENT') || (data.row.cells && data.row.cells[0]?.text === 'PAYMENT');
        const isReturn = (data.row.raw && data.row.raw[0] === 'RETURN') || (data.row.cells && data.row.cells[0]?.text === 'RETURN');
        if (isPayment) {
          data.cell.styles.fillColor = [253, 240, 238];
          data.cell.styles.textColor = [192, 57, 43];
        } else if (isReturn) {
          data.cell.styles.fillColor = [254, 243, 199];
          data.cell.styles.textColor = [180, 83, 9];
        } else if (boldLastColumn && data.column.index === lastColIndex) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.textColor = [64, 23, 4];
        }
      }
    },
    margin: { left: 14, right: 14 }
  });

  // Save/Download PDF
  doc.save(filename);
}
